"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
/* eslint-disable no-console */


var filteredWarnings = [// Optional dependency, where we handle the dependency check on run-time
'@walletconnect/web3-provider'];
/**
 * Filters console messages that include text from the blacklist
 */

var filterConsole = function () {
  var warnFn = console.log;

  console.warn = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string' && (0, _filter.default)(filteredWarnings).call(filteredWarnings, function () {
      var _context;

      return (0, _includes.default)(_context = args[0]).call(_context, args[0]);
    }).length > 1) {
      return;
    }

    return warnFn;
  };
};

module.exports = {
  filterConsole: filterConsole
};